/*

File handles all api calls for tenants


*/
import { browserHistory } from 'react-router'

import { server } from '../engine/server'
import { modal } from '../utilities/modal'

var BuildingControllers = Class.create({
    sensors: null,
    systemCheck: null,
    systemConnected: false,
    currentAvgTemp: 'N/A',
    tempTally: [],
    tempTallyPerFloor: [],
  	initialize: function() {

	},
	getControllers: function(buildingId, callback) {
        var self = this;
		var url = "building/" + buildingId + '/controllers/all';
		var data = server.getData(url,null, true);
		data
		.done(function(response){
            self.tempTally = [];
            self.tempTallyPerFloor = [];
            if(response.data.all_systems_check == 'healthy') {
                self.systemConnected = true,
                self.systemCheck = response.data['hardware'][0].last_system_check,
                self.sensors = response.data.hardware
            }
			callback(response);
		})
		.fail(function(e){
            console.log(e);
		});
    },
    determineAvgTemp: function() {
        if (!this.tempTally) {
            return 'N/A';
        }
        var total = 0;
        const tally = this.tempTally.length;
        this.tempTally.forEach(temp => {
            total += parseFloat(temp);
        });
        const avg = total > 0 ? (total / tally).toFixed(1) : 'N/A';

        this.currentAvgTemp = avg;
    },
    determineAvgTempPerFloor: function(level) {
        if(this.tempTallyPerFloor.length == 0) {
            return 'N/A';
        }
        var total = 0;
        var tally = 0;
        this.tempTallyPerFloor.forEach(floor => {
            if(floor.level == level) {
                tally++;
                total += parseFloat(floor.temp);
            }
        });
        const avg = total > 0 ? (total / tally).toFixed(1) : 'N/A';

        return avg;
    },
    addTempTallyToFloor: function(level_num, temp) {
        buildingControllers.tempTallyPerFloor.push({level: level_num, temp: temp});
    },
    clearAll: function() {
        this.sensors = null;
        this.systemCheck = null;
        this.systemConnected = false;
        this.currentAvgTemp = 'N/A';
        this.tempTally = [];
        this.tempTallyPerFloor = [];
    }
});

export let buildingControllers = new BuildingControllers();


// WEBPACK FOOTER //
// app/core/controllers/BuildingControllers.js